<template>
  <v-container fluid class="pa-0">

    <!-- Toolbar -->
    <v-toolbar light dense :color="appColor_PanelBackgroundLight">
      <v-switch
        v-model="settings.isPrioritize"
        value
        color="primary"
        :disabled="prioritizeDisabled"
        hide-details
        >
        <span slot="label" class="grey--text text--darken-3">
          Prioritize
        </span>
      </v-switch>
    </v-toolbar>
      
    <!-- Draggable of Traits -->
    <v-list light :color="appColor_PanelBackgroundLight">
      <draggable v-if="settings.isPrioritize"
        v-model="traitsContainer.userTraits"
        >
        
        <!-- If: IsPrioritize - Show Drag Handles -->
        <transition-group name="list-complete">
          <template v-for="trait in traitsContainer.userTraits">
            <user-trait
              :key="trait.id"
              class="list-complete-item"
              :criterion="trait"
              :readonly="settings.isPrioritize"
            />
          </template>
        </transition-group>
      </draggable>

      <!-- Else: Hide Drag Handles -->
      <template v-else
        v-for="trait in traitsContainer.userTraits"
        >
        <user-trait
          :key="trait.id"
          :criterion="trait"
          :readonly="settings.isPrioritize"
        />
      </template>
    </v-list>
  </v-container>
</template>

<script>
import UserTrait from '@/components/UserTrait'
import draggable from 'vuedraggable'
import { AppColor } from '@/config.js'

export default {
  name: "UserTraitList",
  components: {
    UserTrait,
    draggable
  },
  props: {
    traitsContainer: {
      type: Object,
      default: null
    },
    settings: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    appColor_PanelBackgroundLight: AppColor.PanelBackgroundLight,
    appColor_Light: AppColor.Light,
    appColor_Selected: AppColor.Selected
  }),
  computed: {
    prioritizeDisabled () {
      return this.traitsContainer.userTraits.length <= 1
    }
  }
}
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
}
.list-complete-enter, .list-complete-leave-active {
  opacity: 0;
}
</style>
